// This is just an example,
// so you can safely delete all default props below

export default {
  failed: 'Action failed',
  success: 'Action was successful',
  index: {
    operation: 'Manual de operações',
    app_store: 'Licença comercial',
    signin: 'Endereço de acesso:',
    app_title: 'título do aplicativo',
    slogan: 'Slogan',
    server: 'URL base de solicitação',
    index_title: 'Plataforma de Gerenciamento de Armazém',
    webtitle: 'GreaterWMS -- Open Source Warehouse Management System',
    home: 'primeira página',
    title: 'GreaterWMS',
    title_tip: 'Página inicial do GreaterWMS',
    hide_menu: 'Fechar menu',
    api: 'Documentação da API',
    translate: 'mudar idioma',
    unread: 'Mensagens não lidas',
    login: 'Conecte-se',
    register: 'registro',
    login_tip: 'Digite seu OPENID e nome de usuário',
    register_tip: 'Registrar como administrador',
    logout: 'Sair',
    user_login: 'Login de usuário',
    admin_login: 'Login de administrador',
    return_to_login: 'voltar ao login',
    user_center: 'Centro do Usuário',
    change_user: 'Mudar usuário',
    view_my_openid: 'Ver meu OPENID',
    your_openid: 'seu OPENID',
    contact_list: 'Contatos recentes',
    chat_more: 'Mais notícias históricas',
    chat_no_more: 'Sem mais notícias',
    chat_send: 'mandar',
    previous: 'Página anterior',
    next: 'Próxima página',
    admin_name: 'administrador',
    password: 'senha',
    confirm_password: 'Confirme a Senha',
    staff_name: 'nome do usuário',
    cancel: 'Cancelar',
    close: 'fecho',
    submit: 'enviar',
    download: 'download',
    updatetitle: 'Atualização pronta',
    updatedesc: 'A versão está pronta para atualização',
    update: 'Atualizar agora',
    chart: 'Relatório',
    current_user: 'Usuário atual'
  },
  Settings: {
    index: 'Definições',
    server: 'Servidor',
    equipment: 'Suporte de equipamentos'
  },
  menuItem: {
    dashboard: 'Painel',
    inbound: 'entrada',
    outbound: 'Saída',
    stock: 'Inventário',
    finance: 'Finanças',
    goods: 'Lista de mercadorias',
    baseinfo: 'Informações básicas',
    warehouse: 'Armazém',
    staff: 'Equipe',
    driver: 'Condutor',
    customerdn: 'DN do cliente',
    supplierasn: 'ASN do fornecedor',
    uploadcenter: 'Centro de upload',
    downloadcenter: 'Centro de download',
    cloudwarehouse: 'Interligação do Armazém'
  },
  contact: 'Comunique-se imediatamente',
  sendmessage: 'Envie-lhe uma mensagem',
  send: 'mandar',
  nomoremessage: 'Sem mais notícias',
  loadmore: 'Carregue mais',
  new: 'Adicionar',
  newtip: 'Adicionar novos dados',
  refresh: 'atualizar',
  refreshtip: 'Atualizar todos os dados',
  edit: 'Editar estes dados',
  confirmedit: 'Confirmar dados de edição',
  canceledit: 'Cancelar dados de edição',
  delete: 'Excluir estes dados',
  deletetip: 'Esta operação é irreversível. ',
  confirmdelete: 'Confirmar exclusão de dados',
  canceldelete: 'Recuperar dados',
  download: 'download',
  downloadtip: 'Baixar todos os dados',
  frombin: 'Do local de armazenamento',
  movetobin: 'Transferir',
  putaway: 'na prateleira',
  cyclecount: 'Inventário dinâmico',
  cyclecountrecorder: 'Registro de estoque',
  search: 'Pesquisa de palavras-chave',
  creater: 'fundador',
  createtime: 'criar tempo',
  updatetime: 'Tempo de atualização',
  action: 'operar',
  previous: 'Página anterior',
  next: 'Próxima página',
  no_data: 'Sem mais dados',
  submit: 'confirme',
  cancel: 'Cancelar',
  estimate: 'Envio Estimado',
  downloadasnlist: 'Baixar lista',
  downloadasndetail: 'Detalhes do download',
  downloadasnlisttip: 'Baixe a lista de notices de chegada',
  downloadasndetailtip: 'Baixe os detalhes do notice de chegada',
  printthisasn: 'Verifique o notice de chegada',
  confirmdelivery: 'A confirmação chegou',
  finishloading: 'Confirmar descarregamento concluído',
  confirmsorted: 'Confirmar classificação completa',
  downloaddnlist: 'Baixar lista',
  downloaddndetail: 'Detalhes do download',
  downloaddnlisttip: 'Baixar lista de faturas',
  downloaddndetailtip: 'Baixar detalhes da fatura',
  release: 'ordem de correspondência',
  releaseallorder: 'Todos geram lista de seleção',
  releaseorder: 'Gerar lista de seleção',
  print: 'Imprimir lista de seleção',
  printthisdn: 'Visualizar e imprimir faturas',
  confirmorder: 'Confirmar pedido',
  confirmpicked: 'Confirmar a coleta completa',
  dispatch: 'Carregamento e entrega',
  deletebackorder: 'Excluir pedido pendente',
  confirminventoryresults: 'Confirmar o resultado da contagem',
  baseinfo: {
    company_info: 'Informações da Empresa',
    supplier: 'fornecedor',
    customer: 'cliente',
    view_company: {
      company_name: 'Nome da empresa',
      company_city: 'Cidade local',
      company_address: 'Morada',
      company_contact: 'Informações de Contato',
      company_manager: 'diretor',
      error1: 'Por favor, digite o nome da empresa',
      error2: 'Por favor, insira a cidade onde a empresa está localizada',
      error3: 'Por favor, digite o endereço da empresa',
      error4: 'Por favor, insira o contato da empresa',
      error5: 'Por favor, insira o responsável pela empresa'
    },
    view_supplier: {
      supplier_name: 'Nome do Fornecedor',
      supplier_city: 'Cidade local',
      supplier_address: 'Morada',
      supplier_contact: 'Informações de Contato',
      supplier_manager: 'diretor',
      supplier_level: 'Nível do fornecedor',
      error1: 'Por favor, digite o nome do fornecedor',
      error2: 'Por favor, insira a cidade onde o fornecedor está localizado',
      error3: 'Por favor, digite o endereço do fornecedor',
      error4: 'Por favor, insira as informações de contato',
      error5: 'Por favor, insira o responsável pelo fornecedor',
      error6: 'Por favor, insira o nível do fornecedor'
    },
    view_customer: {
      customer_name: 'nome do cliente',
      customer_city: 'Cidade local',
      customer_address: 'Morada',
      customer_contact: 'Informações de Contato',
      customer_manager: 'diretor',
      customer_level: 'Nível do cliente',
      error1: 'Por favor, digite o nome do cliente',
      error2: 'Por favor, insira a cidade onde o cliente está localizado',
      error3: 'Por favor, insira o endereço do cliente',
      error4: 'Por favor, insira um contato',
      error5: 'Por favor, digite o gerente da conta',
      error6: 'Por favor, insira o nível do cliente'
    }
  },
  dashboards: {
    outbound_statements: 'Relatório de saída',
    inbound_statements: 'Relatório de recebimento',
    inbound_and_outbound_statements: 'Recebimento e relatório de entrega',
    total_sales: 'Vendas totais',
    category_sales_ranking: 'Classificação de vendas por categoria',
    sales_volume_ranking: 'Classificação de vendas',
    sales_volumes_ranking: 'Número de classificação de vendas',
    total_receipts: 'Recibo Total',
    category_receipt_ranking: 'Classificação de recebimento de categoria',
    receiving_quantity_ranking: 'Classificação da quantidade de recibo',
    Receiving_amount_ranking: 'Classificação de recibo',
    view_tradelist: {
      mode_code: 'meio de transação',
      bin_name: 'Nome do local',
      goods_code: 'Código de mercadoria',
      goods_qty: 'Quantidade disponível',
      creater: 'fundador',
      update_time: 'Tempo de atualização',
      create_time: 'criar tempo',
      inbound: 'Recibo',
      outbound: 'Enviar'
    }
  },
  finance: {
    capital: 'Ativo permanente',
    freight: 'Gestão de Frete',
    view_capital: {
      capital_name: 'Nome do ativo fixo',
      capital_qty: 'quantidade',
      capital_cost: 'Montante',
      error1: 'Por favor, insira o nome do ativo',
      error2: 'O número de ativos deve ser maior que 0',
      error3: 'O valor do ativo deve ser maior que 0'
    },
    view_freight: {
      transportation_supplier: 'Operadora',
      send_city: 'cidade de origem',
      receiver_city: 'cidade de chegada',
      weight_fee: 'Envio por quilo',
      volume_fee: 'Envio de um metro cúbico',
      min_payment: 'Envio mínimo',
      error1: 'Por favor, insira uma operadora',
      error2: 'Por favor, digite a cidade de envio',
      error3: 'Por favor, insira a cidade receptora',
      error4: 'O custo de envio por quilograma deve ser maior que 0',
      error5: 'Custo de envio de metro cúbico único deve ser maior que 0',
      error6: 'Envio mínimo deve ser maior que 0'
    }
  },
  driver: {
    driver: 'Gerenciamento de motoristas',
    dispatchlist: 'Registro de recebimento',
    error1: 'Por favor, digite o nome do motorista',
    error2: 'Por favor, digite o número da placa',
    error3: 'Por favor, insira um contato',
    view_driver: {
      driver_name: 'nome do motorista',
      license_plate: 'número da placa',
      contact: 'Informações de Contato'
    },
    view_dispatch: {
      driver_name: 'nome do motorista',
      dn_code: 'Número do pedido de retirada',
      contact: 'Informações de Contato'
    }
  },
  upload_center: {
    initializeupload: 'Iniciar upload',
    uploadfiles: 'fazer upload de arquivos',
    upload: 'Envio',
    uploadcustomerfile: 'Carregar lista de clientes',
    uploadgoodslistfile: 'Carregar lista de formulários de produtos',
    uploadsupplierfile: 'Carregar lista de fornecedores',
    downloadgoodstemplate: 'Baixar modelo de produto',
    downloadcustomertemplate: 'Baixar modelo de cliente',
    downloadsuppliertemplate: 'Baixar modelo de fornecedor',
    addupload: 'Adicionar carregamento'
  },
  download_center: {
    createTime: 'criar tempo',
    reset: 'Redefinir',
    start: 'Começar',
    end: 'Terminar'
  },
  community_mall: {
    communitymall: 'Alameda Comunitária'
  },
  goods: {
    goods_list: 'Lista de produtos',
    unit: 'Unidade de commodities',
    class: 'Categoria de item',
    color: 'cor do produto',
    brand: 'marca do produto',
    shape: 'Forma do produto',
    specs: 'Especificações do produto',
    origin: 'Origem do produto',
    view_goodslist: {
      goods_code: 'Código de mercadoria',
      goods_desc: 'Descrição do produto',
      goods_name: 'Nome do Produto',
      goods_supplier: 'fornecedor',
      goods_weight: 'Peso da mercadoria (unidade: gramas)',
      goods_w: 'Comprimento do item (unidade: mm)',
      goods_d: 'Largura do produto (unidade: mm)',
      goods_h: 'Altura da mercadoria (unidade: mm)',
      unit_volume: 'Volume unitário mínimo',
      goods_unit: 'Unidade de commodities',
      goods_class: 'Categoria de item',
      goods_brand: 'marca do produto',
      goods_color: 'cor do produto',
      goods_shape: 'Forma do produto',
      goods_specs: 'Especificações do produto',
      goods_origin: 'Origem do produto',
      goods_cost: 'Custo da mercadoria',
      goods_price: 'Preço da mercadoria',
      print_goods_label: 'Imprimir etiqueta do produto',
      error1: 'Por favor, insira o código do produto',
      error2: 'Por favor, insira a descrição do produto',
      error3: 'Por favor, insira o fornecedor do produto',
      error4: 'O peso do item deve ser maior que 0',
      error5: 'O comprimento do item deve ser maior que 0',
      error6: 'A largura do produto deve ser maior que 0',
      error7: 'A altura do produto deve ser maior que 0',
      error8: 'Por favor, insira o custo das mercadorias',
      error9: 'Por favor, insira o preço do produto'
    },
    view_unit: {
      goods_unit: 'Unidade de commodities',
      error1: 'Por favor, insira a unidade do produto'
    },
    view_class: {
      goods_class: 'Categoria de item',
      error1: 'Por favor, insira a categoria do produto'
    },
    view_color: {
      goods_color: 'cor do produto',
      error1: 'Por favor, insira a cor do produto'
    },
    view_brand: {
      goods_brand: 'marca do produto',
      error1: 'Por favor, insira a marca do produto'
    },
    view_shape: {
      goods_shape: 'Forma do produto',
      error1: 'Por favor, insira a forma do produto'
    },
    view_specs: {
      goods_specs: 'Especificações do produto',
      error1: 'Por favor, insira as especificações do produto'
    },
    view_origin: {
      goods_origin: 'Origem do produto',
      error1: 'Por favor, insira a origem do produto'
    }
  },
  inbound: {
    asn: 'notice de chegada',
    predeliverystock: 'chegar',
    preloadstock: 'Para ser descarregado',
    presortstock: 'a ser ordenado',
    sortstock: 'classificado',
    shortage: 'Falta de mercadorias recebidas',
    more: 'Mais chegadas',
    asnfinish: 'Detalhes do recibo',
    asndone: 'Recibo concluído',
    view_sortstock: {
      error1: 'Por favor, insira a quantidade, a quantidade deve ser maior que 0'
    },
    view_asn: {
      asn_code: 'Número do notice de chegada',
      asn_status: 'Status de notificação de chegada',
      goods_qty: 'Número de notices de chegada',
      goods_actual_qty: 'Quantidade real de chegada',
      goods_shortage_qty: 'Chegou em pouca quantidade',
      goods_more_qty: 'Grande quantidade de chegada',
      goods_damage_qty: 'Número de chegadas danificadas',
      presortstock: 'Número a ser classificado',
      sorted_qty: 'Quantidade em estoque',
      total_weight: 'Peso total (unidade: kg)',
      total_volume: 'Volume total (unidade: metro cúbico)'
    }
  },
  outbound: {
    dn: 'Fatura',
    freshorder: 'Pré-fatura',
    neworder: 'Nova fatura',
    backorder: 'Pedidos em espera',
    pickstock: 'ser escolhido',
    pickedstock: 'Escolhido',
    pickinglist: 'Selecionar detalhes da lista',
    shippedstock: 'Enviado',
    received: 'Foi recebido',
    pod: 'Assine o recibo',
    view_dn: {
      dn_code: 'número de envio',
      dn_status: 'Status da fatura',
      goods_qty: 'quantidade do pedido',
      intransit_qty: 'Quantidade enviada',
      delivery_actual_qty: 'Quantidade real de chegada',
      delivery_shortage_qty: 'Chegada curta',
      delivery_more_qty: 'Mais chegadas',
      delivery_damage_qty: 'Chegou danificado',
      total_weight: 'Peso total (unidade: kg)',
      total_volume: 'Volume total (unidade: metro cúbico)',
      customer: 'cliente'
    }
  },
  staff: {
    staff: 'Lista de empregados',
    check_code: 'Código de verificação',
    view_staff: {
      staff_name: 'nome do empregado',
      staff_type: 'tipo de funcionário',
      error1: 'Por favor, digite o nome do funcionário',
      error2: 'Por favor, digite o tipo de funcionário',
      lock: 'bloqueio',
      unlock: 'desbloquear'
    }
  },
  stock: {
    stocklist: 'lista de ações',
    stockbinlist: 'Lista de locais',
    emptybin: 'Local vazio',
    occupiedbin: 'Localização em estoque',
    view_stocklist: {
      goods_code: 'Código de mercadoria',
      goods_desc: 'Descrição do produto',
      goods_qty: 'A quantidade total',
      onhand_stock: 'Quantidade disponível',
      can_order_stock: 'Quantidade que pode ser colocada',
      ordered_stock: 'Número de pedidos feitos',
      inspect_stock: 'Quantidade de inspeção de qualidade',
      hold_stock: 'Quantidade bloqueada',
      damage_stock: 'Quantidade de quebra',
      asn_stock: 'Número de notices de chegada',
      dn_stock: 'Quantidade da fatura',
      pre_load_stock: 'Quantidade a ser descarregada',
      pre_sort_stock: 'Número a ser classificado',
      sorted_stock: 'Número classificado',
      pick_stock: 'Quantidade a ser escolhida',
      picked_stock: 'Quantidade Escolhida',
      back_order_stock: 'Montante de bens devidos',
      on_hand_inventory: 'estoques existentes',
      history_inventory: 'Em estoque no momento',
      physical_inventory: 'Quantidade de contagem',
      difference: 'diferença',
      cyclecount: 'Inventário dinâmico',
      recyclecount: 'Redefinir',
      downloadcyclecount: 'Lista de inventário',
      cyclecountresult: 'verificar resultados',
      cyclecounttip: 'Gerar tabela de inventário dinâmica',
      recyclecounttip: 'Gerar lista de verificação de reabastecimento',
      downloadcyclecounttip: 'Baixar lista de verificação',
      cyclecountresulttip: 'Confirmar o resultado da contagem',
      daychoice: 'Seleção de data',
      daychoicetip: 'Selecione a tabela de inventário correspondente à data',
      error1: 'O número de contagens deve ser maior que 0',
      dateerror: 'Data incorreta selecionada'
    }
  },
  warehouse: {
    warehouse: 'Configurações do armazém',
    binset: 'Configuração de localização de estoque',
    binsize: 'Tamanho do estoque',
    property: 'Propriedade de localização',
    printbin: 'Imprimir etiqueta de localização',
    view_warehouseset: {
      error1: 'Por favor, digite o nome do armazém',
      error2: 'Por favor, insira a cidade onde o armazém está localizado',
      error3: 'Por favor, digite o endereço do armazém',
      error4: 'Por favor, insira as informações de contato do armazém',
      error5: 'Por favor, indique o responsável pelo armazém'
    },
    view_warehouse: {
      warehouse_name: 'nome do armazém',
      warehouse_city: 'Cidade local',
      warehouse_address: 'Morada',
      warehouse_contact: 'Informações de Contato',
      warehouse_manager: 'diretor',
      square_measure: 'Área útil',
      city_search: 'Pesquisa na Cidade',
      publish_warehouse: 'Publicar o Armazém',
      Nopublish_warehouse: 'Recuperar o armazém'
    },
    view_binset: {
      bin_name: 'Nome do local',
      bin_size: 'Tamanho do estoque',
      bin_property: 'Propriedade de localização',
      empty_label: 'ID de local vazio',
      error1: 'Por favor, digite o nome do local',
      error2: 'Por favor, insira o tamanho do local',
      error3: 'Por favor, insira o atributo de localização'
    },
    view_binsize: {
      bin_size: 'Tamanho do estoque',
      bin_size_w: 'Comprimento do estoque (unidade: mm)',
      bin_size_d: 'Largura do estoque (unidade: mm)',
      bin_size_h: 'Altura do estoque (unidade: mm)',
      error1: 'Por favor, insira o tamanho do local',
      error2: 'O comprimento do local de armazenamento deve ser maior que 0',
      error3: 'A largura do estoque deve ser maior que 0',
      error4: 'A altura do estoque deve ser maior que 0'
    },
    view_property: {
      bin_property: 'Propriedades de localização de ações'
    }
  },
  scan: {
    scan: 'digitalização',
    scan_asn: 'consulta ASN',
    scan_dn: 'consulta DN',
    scan_sorting: 'Ordenação',
    scan_uptobin: 'na prateleira',
    scan_picking: 'colhendo',
    scan_shipping: 'Carregamento e entrega',
    scan_movetobin: 'Transferir',
    scan_inventory: 'inventário',
    scan_goodsquery: 'Inquérito de carga',
    scan_locationquery: 'Consulta de localização de estoque',
    scan_goods_code: 'Código de mercadoria',
    scan_bin_name: 'Nome do local',
    scan_goods_label: 'Rótulo do produto',
    scan_goods_label_error: 'rótulo do produto não existe',
    view_binmove: {
      old_bin_name: 'Nome de localização original',
      new_bin_name: 'Novo nome de localização',
      qty: 'Número de bibliotecas movidas',
      qty_error: 'A quantidade de entreposto móvel não deve ser superior à quantidade existente'
    },
    view_upToBin: {
      goods_actual_qty: 'Quantidade real de chegada',
      scan_qty: 'Número verificado',
      scan_qty_error: 'A quantidade verificada não deve ser superior à quantidade de chegada'
    },
    view_picking: {
      order_qty: 'quantidade do pedido',
      picking_qty: 'Quantidade de colheita',
      picking_qty_error: 'A quantidade de colheita não pode ser superior à quantidade de ordem'
    },
    view_shipping: {
      shipping_code: 'número de envio',
      driver_info: 'Informações do condutor',
      license_plate_number: 'número da placa',
      name: 'nome completo',
      contact_info: 'Informações de Contato'
    }
  },
  handcount: {
    handcount: 'Contagem única',
    handcountrecorder: 'Gravador de contagem única',
    update_time: 'Contar tempo'
  },
  notice: {
    valerror: 'Digite o valor correto',
    unknow_error: 'erro desconhecido',
    network_error: 'Excepção de rede',
    nullerror: '',
    cyclecounterror: 'sem dados',
    userererror: 'O nome do utilizador já existe',
    capitalerror: 'O nome do activo fixo já existe',
    valuenullerror: 'Por favor, complete os dados',
    loginerror: 'Por favor, entre primeiro.',
    goodserror: {
      goods_listerror: 'Código do produto já existe',
      goods_uniterror: 'A unidade de mercadorias já existe',
      goods_classerror: 'A categoria de produtos já existe',
      goods_colorerror: 'A cor do item já existe.',
      goods_branderror: 'A marca do produto já existe',
      goods_shapeerror: 'A forma do item já existe',
      goods_specserror: 'A especificação do produto já existe',
      goods_originerror: 'A origem das mercadorias já existe'
    },
    baseinfoerror: {
      companyerror: 'O nome da empresa já existe',
      customererror: 'O nome do cliente já existe',
      suppliererror: 'O nome do fornecedor já existe'
    },
    warehouseerror: {
      binseterror: 'O nome do local já existe',
      binsizeerror: 'O tamanho do estoque já existe'
    },
    mobile_userlogin: {
      notice1: 'Por favor, insira seu nome de administrador',
      notice2: 'Por favor, insira sua senha de administrador',
      notice3: 'Por favor, insira o nome da sua equipe',
      notice4: 'Por favor, insira seu código de verificação de equipe',
      notice5: 'Por favor, insira seu Openid no servidor de configurações',
      notice6: 'Login com sucesso',
      notice7: 'Usuário ou senha não alocado',
      notice8: 'Funcionário ou código de verificação não alocado'
    },
    mobile_scan: {
      notice1: 'Código QR não existe',
      notice2: 'Código não existe',
      notice3: 'Erro do servidor',
      notice4: 'Somente celular pode escanear'
    },
    mobile_asn: {
      notice1: 'Lista ASN',
      notice2: 'Você pode escanear o código QR do notice de chegada ou clicar no notice de chegada para ver os detalhes do notice de chegada e operar',
      notice3: 'Fornecedor:',
      notice4: 'Valor total:',
      notice5: 'Status:',
      notice6: 'Detalhes do notice de chegada',
      notice7: 'Você precisa escanear o notice de chegada para obter os detalhes do notice de chegada. Você pode escanear o código da carga ou clicar nas mercadorias que deseja colocar nas prateleiras para concluir a operação das mercadorias nas prateleiras',
      notice8: 'Detalhes',
      notice9: 'Valor total:',
      notice10: 'Número a ser listado:',
      notice11: 'O número de listagens deve ser maior que 0',
      notice12: 'Listagem bem sucedida',
      notice13: 'Por favor, digite o código de localização'
    },
    mobile_dn: {
      notice1: 'Lista DN',
      notice2: 'Você pode escanear o código QR do pedido DN ou clicar no pedido DN para visualizar os detalhes do DN e realizar operações',
      notice3: 'Cliente:',
      notice4: 'Valor total:',
      notice5: 'Status:',
      notice6: 'detalhes do DN',
      notice7: 'Os detalhes do DN são todas as faturas. Digitalize o número do DN para ver os detalhes do DN específico',
      notice8: 'Detalhes',
      notice9: 'Valor total:',
      notice10: 'Quantidade da fatura:',
      notice11: 'Todos os detalhes da lista de separação estão aqui, você também pode digitalizar as mercadorias específicas, ou o DN para obter a lista de separação a ser operada',
      notice12: 'Por favor, insira a quantidade de separação específica',
      notice13: 'Escolha bem sucedida',
      notice14: 'Nome do compartimento:',
      notice15: 'Quantidade a ser colhida:'
    },
    mobile_goodsstock: {
      notice1: 'Lista de ações',
      notice2: 'Aqui você pode ver todas as informações de inventário, clique para ver as informações de inventário diretamente',
      notice3: 'Estoque disponível:',
      notice4: 'Estoque Encomendado:'
    },
    mobile_binstock: {
      notice1: 'Lista de Estoque Bin',
      notice2: 'Aqui você pode ver as informações de estoque de todos os locais do armazém, clique para acessar diretamente o estoque do local do armazém, realizar a operação de transferência do armazém ou digitalizar as mercadorias para verificar o status de armazenamento de todas as mercadorias',
      notice3: 'Nome do compartimento:',
      notice4: 'Quantidade de armazenamento:',
      notice5: 'Por favor, digite o nome do compartimento',
      notice6: 'Repositório movido com sucesso'
    },
    mobile_emptybin: {
      notice1: 'Lista de lixeiras vazias',
      notice2: 'Aqui você pode ver todos os locais vazios',
      notice3: 'Propriedade da Caixa de Estoque:'
    },
    equitment: {
       notice1: 'Lista de Suporte de Equipamento',
       notice2: 'Todas as marcas de dispositivos e sistemas suportados pelo APP estão listados aqui'
     },
    handcount: {
      notice1: 'Detalhes',
      notice2: 'Contagem Manual',
      notice3: 'Estoque disponível',
      notice4: 'Quantidade de contagem',
      notice5: 'Confirmar resultado',
      notice6: 'Confirme o resultado da contagem',
      notice7: 'Resultado de contagem confirmado com sucesso',
      notice8: 'Aqui mostra os detalhes das mercadorias que precisam ser contadas'
    },
    400: 'Solicitação incorreta (400)',
    401: 'Não autorizado (401)',
    403: 'Acesso negado (403)',
    404: 'O recurso não existe (404)',
    405: 'Este recurso está desabilitado (405)',
    408: 'A solicitação expirou (408)',
    409: 'Conflito de dados (409)',
    410: 'Dados excluídos (410)',
    500: 'Erro do servidor (500)',
    501: 'Serviço não implementado (501)',
    502: 'Erro de rede (502)',
    503: 'Serviço indisponível (503)',
    504: 'Rede expirou (504)',
    505: 'Versão HTTP não suportada (505)'
  }
}
